import type {Guide} from '@blesk-frontend/api';
import {formatLongDate} from '../../libs';
import {cropImage} from './cropImage';
import {escapeHtml} from './escapeHtml';

export const copyAsHtml = async (guide: Guide) => {
  const html = `<p>
  <span style="font-weight: bold;">${guide.user.fullName}</span> - ${formatLongDate(guide.createdAt)}
</p>
<h1>${guide.name}</h1>
<p>${guide.description}</p>
${
  guide.steps.length
    ? `${(
        await Promise.all(
          guide.steps
            .filter((step) => !step.payload.meta.hidden)
            .sort((a, b) => a.position - b.position)
            .map(async (step, index) => {
              const imgSrc = await cropImage(step.payload);
              const stepText = step.payload.element.text;

              return `<p>
${index + 1}. <span>${escapeHtml(stepText || '')}</span><br/>
      ${imgSrc ? `<img style="aspect-ratio: 16/9; width: 740px; object-fit: cover" src="${imgSrc}" alt=""/><br/>` : ''}
    </p>
`;
            }),
        )
      ).join('')}
`
    : ''
}`;

  try {
    const clipboardItem = new ClipboardItem({
      'text/html': new Blob([html], {type: 'text/html'}),
      'text/plain': new Blob([html], {type: 'text/plain'}),
    });

    await navigator.clipboard.write([clipboardItem]);
  } catch (error) {
    alert(`Ошибка копирования: ${error}`);
  }
};
